// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBpu2fuwT4Au4UxkDzvb2DFtKTwKfuUSLs",
  authDomain: "perplexity-news-3aba4.firebaseapp.com",
  projectId: "perplexity-news-3aba4",
  storageBucket: "perplexity-news-3aba4.firebasestorage.app",
  messagingSenderId: "1056351727513",
  appId: "1:1056351727513:web:8a1aff720b72b520592d08",
  measurementId: "G-Q10DSM8J3Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);

export { app, analytics, db, auth };
